import { useState } from "react";
import Modal from "react-modal";
import axios from "axios";
import { toast } from "react-toastify";
import { ButtonSkeleton } from "./CalendarComponents/SkeletonLoader.jsx";
import crossImage from "../../images/singleinvoice/cross-red.svg";
import cancelImage from "../../images/singleinvoice/cancel.svg";

const CancelTimeOffModal = ({ isCancelModalOpen, setIsCancelModalOpen, setModalIsOpen, timeOffId, token, refetchLeaves }) => {
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);

    const handleConfirmCancel = async () => {
        if (!timeOffId) return;
        try {
            setIsSubmitLoading(true);
            await axios.get(`/api/time-off-request/cancel/${timeOffId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            toast.success("Time Off Request canceled successfully!", {
                position: "bottom-right",
                autoClose: 2000,
            });
            setModalIsOpen(false);
            handleCancelCancel();
            refetchLeaves();
        } catch (error) {
            console.error("Cancel error:", error);
        } finally {
            setIsSubmitLoading(false);
        }
    };

    const handleCancelCancel = () => {
        setIsCancelModalOpen(false);
        document.body.classList.remove("ReactModal__Body--open");
    };

    return (
        <Modal
            className="center-modal"
            isOpen={isCancelModalOpen}
            onRequestClose={handleCancelCancel}
            contentLabel="Confirm Cancel"
            style={{
                content: {
                    width: "300px",
                    height: "200px",
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    borderRadius: "12px",
                    background: "#fff",
                    boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
                    border: "none",
                },
                overlay: {
                    backgroundColor: "rgba(0,0,0,0.5)",
                },
            }}
        >
            <div className="delete-modal-content">
                <h2>Confirm Cancel</h2>
                <p>Are you sure you want to Cancel this Time Off Request?</p>
                <div className="delete-modal-buttons">
                    <button
                        className="modal-btn modal-btn-calendar cancel-border"
                        onClick={handleConfirmCancel}
                        disabled={isSubmitLoading}
                    >
                        {isSubmitLoading ? (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                <ButtonSkeleton width="70px" height="18px" />
                            </div>
                        ) : (
                            <span className="cancel-border-inner">
                                Cancel
                                <img src={cancelImage} alt="Reject" />
                            </span>
                        )}
                    </button>
                    <button
                        className="modal-btn modal-btn-calendar cancel"
                        onClick={handleCancelCancel}
                        disabled={isSubmitLoading}
                    >
                        {isSubmitLoading ? (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                <ButtonSkeleton width="55px" height="18px" />
                            </div>
                        ) : (
                            "Close"
                        )}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default CancelTimeOffModal;